import type { DependsOnType } from '../page';

export enum RunBehaviourEnums {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic',
}

export type JavaScriptFunction = {
  id: string;
  createdTime: number;
  functionBody: string;
  name: string;
  dataSourceIds?: string[];
  dpOn?: DependsOnType[];
  parentId?: string;
  runBehaviour?: RunBehaviourEnums;
};

export type JavaScriptFunctionState =
  | (JavaScriptFunction & {
      value?: unknown;
      error?: { message: string; stack: string };
      isEvaluated?: true;
    })
  | undefined;
